import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../layout/Sidebar";
import Home from "../pages/Home";
import BookmarkComponent from "../pages/Bookmarks";
import PlayerDetail from "../components/PlayerDetail";
import { useSidebar } from "../contexts/SidebarContext";
import ClubDetail from "../components/ClubDetail";
import ClubsComponent from "../pages/Clubs";
import LogoutComponent from "../components/Logout";
import PlayerSearchComponent from "../pages/Players/PlayerSearchComponent";
import PlayerSearchInitiate from "../pages/Players/PlayerSearchInitiate";
import Presentation from "../pages/Presentation";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import ClubSearchInitiate from "../pages/Clubs/ClubSearchInitiate";
import SortListComponent from "../pages/Shortlists/index";
import PlayerComparisionTool from "../components/PlayerComparison/PlayerComparisonTool";
import ClubComparisonTool from "../components/ClubComparison/ClubComparisonTool";
import ClubSearchComponent from "../components/ClubSearch/ClubSearchComponent";
import HomePage from "../pages/HomePage";
export const DashboardRoutes: React.FC = () => {
  const { isOpen, subMenuOpen, isBlurred } = useSidebar();
  return (
    <div>
      <Sidebar />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<HomePage toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen}/>}/> 
        <Route path="/presentation/:presentId" element={<Presentation toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} />} />
        <Route path="/simulation" element={<Home toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} />} />
        <Route path="/bookmarks" element={<BookmarkComponent toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} />} />
        <Route path="/playersearch" element={<PlayerSearchInitiate />} />
        <Route path="/playersearchresult" element={<PlayerSearchComponent />} />
        <Route path="/clubsearch" element={<ClubSearchInitiate />} />
        <Route path="/clubsearchresult" element={<ClubSearchComponent />} />
        <Route path="/clubs" element={<ClubsComponent toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} />} />
        <Route path="/player/:playerId" element={<PlayerDetail toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} />} />
        <Route path="/club/:teamId" element={<ClubDetail toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen} isBlurred={isBlurred!} />} />
        <Route path="/playercomparison" element={<PlayerComparisionTool/>} /> 
        <Route path="/shortlists/playercomparison/:userId" element={<PlayerComparisionTool/>} />
        <Route path="/shortlists/clubcomparison/:userId" element={<ClubComparisonTool/>} />
        <Route path="/clubcomparison" element={<ClubComparisonTool/>} />
        <Route path="/shortlists" element={<SortListComponent  toggle={!!isOpen} isSubSidebarOpen={!!subMenuOpen}/>} />
        <Route path="/logout" element={<LogoutComponent />} />
        <Route path="/notfound" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};
